import React from "react";
import Layout from "../../layout";

const Dashboard = () => {
  return (
    <>
      <Layout titulo="Ibraflex - Painel">
        <div className="middle-box text-center">
          <img
            src="https://ibraflex.com/wp-content/uploads/2025/07/logo-ibraflex.png"
            alt="Ibraflex"
            style={{ opacity: 0.5 }}
          />
        </div>
      </Layout>
    </>
  );
};

export default Dashboard;
